<script lang="ts" setup>
// ================================
// IMPORTS
// ================================
// Vue
import { computed } from "vue"

// Store
import { useSourceStore } from "@core/stores/source.store"
import { storeToRefs } from "pinia"
const sourceStore = useSourceStore()

const { getSourceById } = storeToRefs(sourceStore)

// ================================
// TYPES & INTERFACES
// ================================
type Props = {
    /**
     * Identifiant du compteur
     */
    meterId: string
}

// ================================
// PROPS & EMITS
// ================================
const props = defineProps<Props>()

// ================================
// COMPUTED PROPERTIES
// ================================

/**
 * Computed pour récupérer les infos de la source
 */
const source = computed(() => {
    return getSourceById.value(props.meterId)
})

/**
 * Indique si les onglets doivent être affichés
 * 1 - Si aucune demande de consentement, on affiche les onglets
 */
const isDisplayTabs = computed(() => {
    const hasConsentRequest = !!source?.value?.consentrequest

    return !hasConsentRequest
})
</script>

<template>
    <BaseCard class="meter_card p-4 md:p-6">
        <!-- Header -->
        <template #header>
            <MeterCardHeader :meter-id="meterId" class="mb-6" />
        </template>
        <!-- Contenu -->
        <template #content>
            <!-- Si le consentement est TERMINATED ou absent, on affiche les onglets (sauf si demande REFUSED) -->
            <MeterCardTab v-if="isDisplayTabs" :meter-id="meterId" />
            <!-- Sinon on affiche l'état de l'invitation (PENDING, REFUSED, etc.) -->
            <MeterCardInvitation v-else :meter-id="meterId" />
        </template>
    </BaseCard>
</template>

<style scoped>
.meter_card {
    --p-card-body-padding: 0;
}
:deep(.p-tabview-panels) {
    padding: 0;
}
</style>
